import Proposal from "@/models/Proposal/Proposal.js";

export default function AreAllProposalTicketsCheckAcceptedQuery(id) {
    const data = Proposal.query().with('groupTickets.checkState').find(id);

    for (const product of data.groupTickets || []) {
        if (!product.checkState?.IsAccepted()) {
            return false;
        }
    }

    return true;
}
